module.exports = [{
      plugin: require('/var/lib/jenkins/workspace/bz-rfq-pr-deploy/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography.js"},
    },{
      plugin: require('/var/lib/jenkins/workspace/bz-rfq-pr-deploy/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-PLJXC6W","includeInDevelopment":true},
    },{
      plugin: require('/var/lib/jenkins/workspace/bz-rfq-pr-deploy/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
